import { useEffect, useRef } from 'react';

const consorcios = [
  {
    name: 'Porto Seguro',
    desc: 'Solidez e qualidade reconhecidas no mercado financeiro brasileiro.',
    icon: 'ri-shield-star-line',
    color: 'bg-blue-50',
    iconColor: 'text-blue-500',
    badge: 'Destaque',
    large: true,
  },
  {
    name: 'Rodobens',
    desc: 'Forte em imóveis e veículos, com décadas de tradição.',
    icon: 'ri-home-4-line',
    color: 'bg-orange-50',
    iconColor: 'text-orange-500',
    badge: 'Imóveis & Veículos',
    large: false,
  },
  {
    name: 'Embracon',
    desc: 'Tradição e variedade em planos de consórcio.',
    icon: 'ri-building-2-line',
    color: 'bg-purple-50',
    iconColor: 'text-purple-500',
    badge: 'Tradição',
    large: false,
  },
  {
    name: 'Consórcio Honda',
    desc: 'Líder absoluto no segmento de motos no Brasil.',
    icon: 'ri-motorbike-line',
    color: 'bg-red-50',
    iconColor: 'text-red-500',
    badge: 'Líder em Motos',
    large: false,
  },
  {
    name: 'Bancos (BB, Bradesco, Itaú, Santander)',
    desc: 'Segurança e crédito facilitado pelos maiores bancos do país.',
    icon: 'ri-bank-line',
    color: 'bg-green-50',
    iconColor: 'text-green-600',
    badge: 'Segurança',
    large: false,
  },
  {
    name: 'Ademicon',
    desc: 'Especialista em consórcios de imóveis com foco no cliente.',
    icon: 'ri-community-line',
    color: 'bg-teal-50',
    iconColor: 'text-teal-500',
    badge: 'Imóveis',
    large: false,
  },
  {
    name: 'Mycon',
    desc: 'Modelo digital com taxas menores e processo simplificado.',
    icon: 'ri-smartphone-line',
    color: 'bg-indigo-50',
    iconColor: 'text-indigo-500',
    badge: 'Digital',
    large: false,
  },
];

export default function Consorcios() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.card-anim').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 80);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="consorcios" className="py-20 md:py-28 bg-white" ref={sectionRef}>
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div>
            <span className="text-green-600 font-semibold text-sm uppercase tracking-wider">Cobertura Ampla</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">
              Principais Consórcios Atendidos
            </h2>
          </div>
          <p className="text-gray-500 text-sm max-w-xs">
            Atuamos com os maiores grupos de consórcio do Brasil.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {consorcios.map((c) => (
            <div
              key={c.name}
              className={`card-anim ${c.large ? 'sm:col-span-2 lg:col-span-2' : ''} ${c.color} rounded-2xl p-6 border border-gray-100 hover:border-green-300 transition-all duration-300 hover:scale-[1.02] relative group cursor-default`}
              style={{ opacity: 0, transform: 'translateY(20px)', transition: 'opacity 0.4s ease, transform 0.4s ease, border-color 0.3s, transform 0.3s' }}
            >
              <div className="absolute top-4 right-4">
                <span className="bg-green-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                  {c.badge}
                </span>
              </div>
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 bg-white`}>
                <i className={`${c.icon} ${c.iconColor} text-2xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-lg mb-1">{c.name}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{c.desc}</p>
              <div className="mt-4 flex items-center gap-1 text-green-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-check-line"></i>
                Atendemos este consórcio
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm">
            Não encontrou o seu?{' '}
            <button
              onClick={() => document.getElementById('simulador')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-green-600 font-semibold hover:underline cursor-pointer whitespace-nowrap"
            >
              Fale com nossos especialistas
            </button>
          </p>
        </div>
      </div>
    </section>
  );
}
